import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { logoutUser } from "../../actions/authActions";
import ViewProfile from "./ViewProfile";
import { Link } from "react-router-dom";
import isEmpty from "../../validation/is-empty";
import { IMAGE_URI } from "../../utils/config";
import ChangePassword from "./ChangePassword";

export class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowViewProfile: false,
      isShowChangePassword: false
    };
  }
  handleCancelViewProfile = () => {
    this.setState({ isShowViewProfile: false });
  };
  handleViewProfile = () => {
    this.setState({ isShowViewProfile: true });
  };
  handleCancelChangePassword = () => {
    this.setState({ isShowChangePassword: false });
  };
  handleShowChangePassword = () => {
    this.setState({ isShowChangePassword: true });
  };
  render() {
    const { user } = this.props.auth;
    const { isShowViewProfile, isShowChangePassword } = this.state;
    return (
      <Fragment>
        <header className="main-header">
          <Link to="/dashboard" className="logo">
            <b>Aqar</b>
          </Link>

          <nav className="navbar navbar-static-top">
            <a
              /*href="#"*/
              className="sidebar-toggle"
              data-toggle="offcanvas"
              role="button"
            >
              <span className="sr-only">Toggle navigation</span>
            </a>
            <div className="navbar-custom-menu">
              <ul className="nav navbar-nav">
                <li className="dropdown user user-menu">
                  <a className="dropdown-toggle" data-toggle="dropdown">
                    {isEmpty(user.attachment) ? (
                      <img
                        className="user-image"
                        src={require("../../assets/dist/img/user2-160x160.jpg")}
                        alt={user.name}
                      />
                    ) : (
                      <img
                        className="user-image"
                        src={`${IMAGE_URI}/${user.attachment.dir}/${user.attachment.filename}`}
                        alt={user.name}
                      />
                    )}
                    <span className="hidden-xs">{user.name}</span>
                  </a>
                  <ul className="dropdown-menu">
                    <li className="user-header">
                      {isEmpty(user.attachment) ? (
                        <img
                          className="img-circle"
                          src={require("../../assets/dist/img/user2-160x160.jpg")}
                          alt={user.name}
                        />
                      ) : (
                        <img
                          className="img-circle"
                          src={`${IMAGE_URI}/${user.attachment.dir}/${user.attachment.filename}`}
                          alt={user.name}
                        />
                      )}
                      <p>
                        {user.name}
                        {/* <small>Member since {user.created_at}</small> */}
                        <small>
                          <a
                            style={{ color: "#fff" }}
                            onClick={this.handleShowChangePassword}
                          >
                            <i className="fa fa-lock" aria-hidden="true"></i>{" "}
                            Change password
                          </a>
                        </small>
                      </p>
                    </li>

                    {/*  <li className="user-body">
                  <div className="col-xs-4 text-center">
                    <a>Followers</a>
                  </div>
                  <div className="col-xs-4 text-center">
                    <a>Sales</a>
                  </div>
                  <div className="col-xs-4 text-center">
                    <a>Friends</a>
                  </div>
                </li> */}

                    <li className="user-footer ">
                      <a
                        /*href="#"*/ className="pull-left btn btn-default"
                        style={{ clear: "none", display: "initial" }}
                        onClick={this.handleViewProfile}
                      >
                        Profile
                      </a>
                      <a
                        /*href="#"*/ className="pull-right btn btn-default"
                        style={{ clear: "none", display: "initial" }}
                        onClick={() => this.props.logoutUser()}
                      >
                        Sign out
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </nav>
        </header>
        {isShowViewProfile ? (
          <ViewProfile
            handleCancelViewProfile={this.handleCancelViewProfile}
            user={user}
          />
        ) : null}
        {isShowChangePassword ? (
          <ChangePassword
            handleCancelChangePassword={this.handleCancelChangePassword}
            user={user}
          />
        ) : null}
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, { logoutUser })(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js